<!-- 订单详情页面 -->
<template>
    <div class='container'>
        <div class="orderDetailTitle">
            <p style="font-weight: bold;">订单详情</p>
            <div v-if="isShowTopBtn" class="orderDetailTitleButton">
                <el-button size="mini" @click="goAxisTravel" type="primary">前往订单行程轴</el-button>
                <el-button size="mini" @click="$emit('updateCurrent', 'my')" type="primary">返回主订单列表</el-button>
            </div>
        </div>
        <div class="orderDetailMain">
            <p class="p1">订单状态</p>
            <orderStatus :tableData="tableData"></orderStatus>
        </div>
        <div class="orderDetailMain">
            <p class="p1">基本信息</p>
            <basicInformation :tableData="tableData"></basicInformation>
        </div>
        <div class="orderDetailMain">
            <div class="orderDetailMainTitle">
                <div style="display: flex;align-items: center;">
                    <p style="margin-right: 0.1rem;font-weight: bold;">发票信息</p>
                    <el-button size="mini" type="primary">修 改</el-button>
                    <el-button size="mini" type="primary">保 存</el-button>
                </div>
            </div>
            <invoiceInformation v-if="tableData.length > 0" @userAddressId="addressId = $event" :invoicingId="invoicingId">
            </invoiceInformation>
        </div>
        <div class="orderDetailMain">
            <div class="orderDetailMainTitle">
                <div style="display: flex;align-items: center;">
                    <p style="margin-right: 0.1rem;font-weight: bold;">收货人信息(旅游产品未预定确认信息接收人)</p>
                    <el-button size="mini" type="primary">修 改</el-button>
                    <el-button size="mini" type="primary">保 存</el-button>
                </div>
            </div>
            <consigneeInformationVue :addressId="addressId"></consigneeInformationVue>
        </div>
        <div class="orderDetailMain">
            <p class="p1">供应商信息</p>
            <supplierInformationVue :orderId="datas.orderMainId"></supplierInformationVue>
        </div>
        <div class="orderDetailMain">
            <div class="orderDetailMainTitle">
                <p class="p1">订单信息</p>
                <div v-if="tableData.length > 0">
                    订单金额: <span class="span1">{{ tableData[0].orderPrice }}元</span> 订单总配送费: +0.00元 订单优惠金额:
                    {{ tableData[0].integralPrice + tableData[0].couponPrice }}元 已付款: <span class="span1">
                        {{ tableData[0].payPrice }}元</span>
                </div>
            </div>
            <staticTableVue :loading="loading" :tableData="listDatas"></staticTableVue>
            <Pagination :currentPage="init.page" :pageSizes="pageSizes" :parentPageSize="10" :totalNumber="AllpagesNum"
                @loadTable='loadTable'></Pagination>
        </div>
<!--        <div class="orderDetailMain">-->
<!--            <p class="p1">操作信息</p>-->
<!--            <operationInformationVue></operationInformationVue>-->
<!--        </div>-->
    </div>
</template>

<script>
import orderStatus from './orderDetailChild/orderStatus.vue';
import basicInformation from "./orderDetailChild/basicInformation.vue";
import invoiceInformation from './orderDetailChild/invoiceInformation.vue';
import consigneeInformationVue from './orderDetailChild/consigneeInformation.vue';
import supplierInformationVue from './orderDetailChild/supplierInformation.vue';
import staticTableVue from './staticTable.vue';
import operationInformationVue from './orderDetailChild/operationInformation.vue';
import OrderApi from '@/components/Api/order'
import { sortByCreateTime } from '@/assets/utils/unit'
import { OrderMinxin } from '../sonOrderMinxin'
import Pagination from '@/components/Pagination.vue'
export default {
    components: {
        orderStatus,
        basicInformation,
        invoiceInformation,
        consigneeInformationVue,
        supplierInformationVue,
        staticTableVue,
        operationInformationVue,
        Pagination
    },
    mixins: [OrderMinxin],
    props: {
        datas: {
            type: Object,
            default: {}
        },
        isShowTopBtn:{
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            addressId: null,
            AllpagesNum: 0,
            pageSizes: [10, 15, 20, 25],
            init: {
                "page": 1,
                "q": {
                    orderMainId: null,
                    type: 0
                },
                "size": 10
            },
            loading: true,
            listDatas: [],
            tableData: [],
            invoicingId: null,//发票id
        }
    },
    computed: {
        // totalPriceCalculation() {
        //     let price = 0
        //     this.listDatas.forEach(item => {
        //         item.orderListDetailResultList.forEach(item1 => {
        //             price += item1.totalPrice
        //         })
        //     })
        //     return price
        // }
    },
    watch: {},
    methods: {
        //前往订单行程轴
        goAxisTravel() {
            this.$store.commit('setPlanId', this.datas.planId)
            this.$store.commit('setBudgetMainId', '')
            this.$router.push({ name: "plan" });
            this.$store.commit('setCheckIndex', 3)
            this.$store.commit("setRightPopupIndex", 0)
        },
        //获取子订单信息
        orderList() {
            this.init.q.orderMainId = this.datas.orderMainId
            new OrderApi('order').platOrderList(this.init).then(res => {
                if (res.status === 200) {
                    this.listDatas = res.data.records
                    this.listDatas.forEach((item) => {
                        if (item.truncationResult.opLogResults) {
                            item.truncationResult.opLogResults = sortByCreateTime(item.truncationResult.opLogResults)
                        }
                    })
                    this.AllpagesNum = res.data.total
                    this.loading = false
                } else {
                    this.$message.error({ message: res.statusText })
                    this.loading = false
                }
            })
        },
        myExpensesList() {
            let obj = {
                "page": 1,
                "q": {
                    "status": 3,
                    "splitStatus": ["1A"],
                    "orderMainId": this.datas.orderMainId
                },
                "size": 10
            }
            this.loading = true
            new OrderApi("order")
                .myExpenses(obj)
                .then((res) => {
                    if (res.status == 200) {
                        this.tableData = res.data.records
                        if (this.tableData.length > 0) {
                            this.invoicingId = this.tableData[0].invoicingId
                        }
                    } else {
                        this.$message.error({ message: res.statusText });
                    }
                });
        },
        loadTable(page, size) {
            this.init.size = size
            this.init.page = page
            this.loading = true
            this.orderList()
        },
    },
    created() {
    },
    beforeDestroy() {
        this.$Bus.$off("PAY_SUCCESS");
    },
    mounted() {
        this.$Bus.$on("PAY_SUCCESS", (data, _find) => {
            this.orderList()
        });
        this.orderList()
        this.myExpensesList()

        console.log(this.datas,'dldlldldld')
    },
}
</script>
<style lang='scss' scoped>
.container {
    .orderDetailTitle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.2rem;
    }

    .orderDetailMain {
        margin-bottom: 0.15rem;

        .orderDetailMainTitle {
            margin-bottom: 0.1rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-weight: bold;

            .span1 {
                color: red;
            }
        }

        .p1 {
            margin-bottom: 0.1rem;
            font-weight: bold;
        }
    }
}
</style>